/* eslint-disable */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { findLowerAndUpperLimit } from './utils/findLowerAndUpperLimit.js';
import { getImageUrlFromProductImages, getImageAltTextFromProductImages } from '../utils';
export { default as EstimatedDeliveryDate } from './views/estimatedDeliveryDate.js';
import Modal from '../components/common/Modal.js';
import { moveAllNonDeliverableItemToCloset, setMoveToClosetModal } from './actions/index.js';
import { ModalTypes } from '../constants/index.js';
import { showModal, hideModal } from '../actions/shared/modal';
import { getServiceOrNonServicabilityItems } from './utils/utils.js';
import { getDateRange } from './utils/getDateRange.js';
import { readAppliedDeliveryOption, SHIPPING_ACTION } from './utils/appliedDeliveryOption.js';
import { readCookie, createCookie, eraseCookie } from '../utils/Cookie';
import { addProductToWishlist } from '../wishlist/actions/wishlist';
import { setCartPaymentOOSError } from '../cart/actions/cart';
import Dialog from '../refresh/molecules/Dialog';
import Text from '../refresh/atoms/Text';
import { beautyCheck } from '../utils/StandardSizeUtils';
import ProductLabel from '../refresh/molecules/ProductLabel';
import properties from '../modules/ajio-util/properties';
import { gtmPagePush, gtmEventPush } from '../modules/ga/GTMdatalayer';
import screen from '../refresh/constants/pageType.constant';

import { getCurrentStore } from '../refresh/selectors/metaData';
import { getLuxeFlags, getAssuredGifts } from '../Flags/selectors';
import {
  getAssuredGiftsFlag,
  getAssuredFlags,
  getGiftWithProductEnable,
  getPriorityDeliveryPreOrderFlag,
  getPriorityDeliveryConfig,
  getEnableAjioMemberShipProgram,
  getAjioMemberShipConfig,
  getPriorityDeliverySLPTagsConfig,
  getPriorityDeliveryPhase2Flag,
  getRushDeliveryFlag,
  getReturnCodCommunication,
  getEnableNonReturnableProductRevamp,
  getEnableNonReturnableProductRevampConfig,
  getB2cSellerFlag
} from '../refresh/selectors/featureFlagsSelector';
// TODO - Remove this mock data used
import Divider from '../refresh/atoms/Divider';
import Image from '../refresh/atoms/ImageView';
import { fetchAssuredGift } from '../actions/assuredGiftsActions';
import { getAssuredGiftData } from '../refresh/selectors/cartSelector';
import AssuredGiftsWidget from './components/AssuredGiftWidget';
import { Feature, Variant } from '../refresh/organism/ABFeature';
import { setGADateFormat } from './../utils/dateFormatter';
import { SubscriptionStaticKeys } from '../constants/subscriptionStaticKey.js';
import { extractRange, manageSizeName } from './../utils/sizeConstants.js';
import { replaceWithJioCDN } from '../utils/imageHandling.js';
import {
  computeReturnPolicyFlags,
  computeReturnMessages,
  getReturnPolicyIcons
} from '../utils/returnPolicyUtils';

const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;

function getReturnPolicySection(item, revampConfig, isGSTSelected, isMobile = false) {
  const rowClass = isMobile ? 'msite-return-policy-row' : 'edd-return-policy-row';
  const itemClass = isMobile ? 'msite-return-policy-item' : 'edd-return-policy-item';
  const labelClass = isMobile ? 'msite-return-policy-label' : 'edd-return-policy-label';
  const strikeoutWrapperClass = isMobile ? 'msite-return-policy-strikeout-wrapper' : 'edd-return-policy-strikeout-wrapper';
  const nonReturnableLabelWrapperClass = isMobile ? 'msite-non-returnable-label-wrapper' : 'desktop-non-returnable-label-wrapper';
  const {
    returnWindow,
    isReturnable,
    isExchangeable,
    isCatalogFraudReturnable,
    isCatalogFraudExchangeable,
    fraudBlocksReturn,
    fraudBlocksExchange,
    gstBlocksExchange,
    exchangeBlocked
  } = computeReturnPolicyFlags(item, isGSTSelected);

  const {
    returnMsg,
    exchangeMsg,
    returnAndExchangeMsg,
    messageNoReturnAndExchangeDesktop,
    messageNonReturnableDesktop,
    messageNoExchangeDesktop
  } = computeReturnMessages(revampConfig, returnWindow, isMobile);

  const { nonReturnableTickSvg, nonReturnableCloseSvg } = getReturnPolicyIcons(
    properties.getProperty('imageBaseUrl')
  );

  let returnPart = null;
  if (isReturnable && returnWindow > 0) {
    returnPart = (
      <span className={itemClass}>
        <img src={nonReturnableTickSvg} alt="return icon" />
        <span>{returnMsg}</span>
      </span>
    );
  } else if (fraudBlocksReturn) {
    returnPart = (
      <span className={itemClass}>
        <span className={strikeoutWrapperClass}>
          <img src={nonReturnableTickSvg} alt="return icon" />
          <span>{returnMsg}</span>
        </span>
        {nonReturnableLabelWrapperClass ? (
          <span className={nonReturnableLabelWrapperClass}>
            <img src={nonReturnableCloseSvg} alt="non returnable icon" />
            <span className={labelClass}>{messageNonReturnableDesktop}</span>
          </span>
        ) : (
          <>
            <img src={nonReturnableCloseSvg} alt="non returnable icon" />
            <span className={labelClass}>{messageNonReturnableDesktop}</span>
          </>
        )}
      </span>
    );
  } else if (!isReturnable && (isExchangeable || fraudBlocksExchange)) {
    returnPart = (
      <span className={itemClass}>
        <img src={nonReturnableCloseSvg} alt="non returnable icon" />
        <span className={labelClass}>{messageNonReturnableDesktop}</span>
      </span>
    );
  }

  let exchangePart = null;
  if (isExchangeable && returnWindow > 0 && !gstBlocksExchange) {
    exchangePart = (
      <span className={itemClass}>
        <img src={nonReturnableTickSvg} alt="exchange icon" />
        <span>{exchangeMsg}</span>
      </span>
    );
  } else if (exchangeBlocked) {
    exchangePart = (
      <span className={itemClass}>
        <span className={strikeoutWrapperClass}>
          <img src={nonReturnableTickSvg} alt="exchange icon" />
          <span>{exchangeMsg}</span>
        </span>
        {nonReturnableLabelWrapperClass ? (
          <span className={nonReturnableLabelWrapperClass}>
            <img src={nonReturnableCloseSvg} alt="no exchange icon" />
            <span className={labelClass}>{messageNoExchangeDesktop}</span>
          </span>
        ) : (
          <>
            <img src={nonReturnableCloseSvg} alt="no exchange icon" />
            <span className={labelClass}>{messageNoExchangeDesktop}</span>
          </>
        )}
      </span>
    );
  }

  const noExchangePart =
    fraudBlocksReturn && !isExchangeable && !isCatalogFraudExchangeable ? (
      <span className={itemClass}>
        <img src={nonReturnableCloseSvg} alt="no exchange icon" />
        <span className={labelClass}>{messageNoExchangeDesktop}</span>
      </span>
    ) : null;

  const hasStrikeout = fraudBlocksReturn || exchangeBlocked;

  if (!returnPart && !exchangePart && !noExchangePart) {
    return (
      <div className={rowClass}>
        <span className={itemClass}>
          <img src={nonReturnableCloseSvg} alt="non returnable icon" />
          <span className={labelClass}>{messageNoReturnAndExchangeDesktop}</span>
        </span>
      </div>
    );
  }

  if (isReturnable && isExchangeable && returnWindow > 0 && !gstBlocksExchange) {
    return (
      <div className={rowClass}>
        <span className={itemClass}>
          <img src={nonReturnableTickSvg} alt="return exchange icon" />
          <span>{returnAndExchangeMsg}</span>
        </span>
      </div>
    );
  }

  if (hasStrikeout) {
    return (
      <>
        {returnPart && <div className={rowClass}>{returnPart}</div>}
        {(exchangePart || noExchangePart) && (
          <div className={rowClass}>
            {exchangePart}
            {noExchangePart}
          </div>
        )}
      </>
    );
  }

  return (
    <div className={rowClass}>
      {returnPart}
      {exchangePart}
      {noExchangePart}
    </div>
  );
}

class NotDeliverableItems extends PureComponent {
  render() {
    const {
      cartItem,
      eddDetails,
      activePincode,
      showHeader = true,
      isAssured,
      assuredConstants,
      assuredDataFlag,

      //actions
      showModal,
      setMoveToClosetModal,
      moveAllNonDeliverableItemToCloset,
      getTitle,
      isShowingInModal = false,
      showItemDeliverable,
      device = '',
      gtmObj,
      luxeFlags,
      name,
      newDesignLuxe,
      fetchAssuredGift,
      assuredData,
      enableGiftWithProduct,
      enablePriorityDelivery=false,
      priorityDeliveryConfig={},
      enableSubscription,
      ajioMembershipConfig,
      memberShipStaticValues,
      priorityDeliverySLPTagsConfig={},
      enablePDPhase2 = false,
      enableRushDelivery= false
    } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';

    let items = getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, false);
    return (
      <CartItemsWithEDD
        items={items}
        header={'Non Deliverable Items'}
        isDeliverableItems={false}
        cartItem={cartItem}
        moveAllNonDeliverableItemToCloset={moveAllNonDeliverableItemToCloset}
        setMoveToClosetModal={setMoveToClosetModal}
        showModal={showModal}
        showItemDeliverable={showItemDeliverable}
        showHeader={showHeader}
        getTitle={getTitle}
        pincode={activePincode}
        isShowingInModal={isShowingInModal}
        device={device}
        gtmObj={gtmObj}
        eddDetails={eddDetails}
        luxe={luxe}
        newDesignLuxe={newDesignLuxe}
        name={name}
        fetchAssuredGift={fetchAssuredGift}
        assuredData={assuredData}
        isAssured={isAssured}
        assuredConstants={assuredConstants}
        assuredDataFlag={assuredDataFlag}
        enableGiftWithProduct={enableGiftWithProduct}
        enablePriorityDelivery={enablePriorityDelivery}
        priorityDeliveryConfig={priorityDeliveryConfig}
        enableSubscription={enableSubscription}
        ajioMembershipConfig={ajioMembershipConfig}
        memberShipStaticValues={memberShipStaticValues}
        priorityDeliverySLPTagsConfig={priorityDeliverySLPTagsConfig}
        enablePDPhase2={enablePDPhase2}
        enableRushDelivery={enableRushDelivery}
      />
    );
  }
}

class CartItemsWithEDD extends PureComponent {
  setMoveToClosetModal = () => {
    const { device = '' } = this.props;
    this.props.setMoveToClosetModal(true);
    device !== 'mobile' && this.props.showModal(ModalTypes.EDD_MOVE_TO_CLOEST, {});
    device === 'mobile' && this.props.showItemDeliverable();
  };
  handleError(event) {
    event.target.src = `${properties.getProperty('imageBaseUrl')}/static/img/placeHolder.svg`;
  }
  componentDidMount() {
    const {
      items,
      isDeliverableItems = true,
      gtmObj: { default_address, default_address_pincode = '' } = {},
      cartItem = [],
      eddDetails,
      pincode,
      name,
      luxe,
      newDesignLuxe,
      cart = {},
      fetchAssuredGift,
      assuredData,
      assuredDataFlag,
      assuredConstants,
      isAssured
    } = this.props;
    const { shippingAssuredGifts = 'OFF' } = isAssured;
    const { orderSummary: { orderTotal: { value = 0 } = {} } = {} } = cart;
    let totalNSItem = 0;
    let totalOOSItem = 0;
    let totalOOSItemList = '';
    let errorType = 'NS';
    let errorMsg = 'Product not serviceable';
    let oosError = 'OOS';
    let oosErrorMsg = 'Product out of stock';

    items.forEach(item => {
      const { reasonForNotServiceability, code } = item;
      if (reasonForNotServiceability === 'NS') {
        totalNSItem = totalNSItem + 1;
      }
      if (reasonForNotServiceability === 'OOS') {
        totalOOSItem = totalOOSItem + 1;
        totalOOSItemList = totalOOSItemList + code;
      }
    });
    if (!isDeliverableItems) {
      const { shipping: { pageName = '', pageType = '' } = {} } = screen;
      let items = getServiceOrNonServicabilityItems(cartItem, eddDetails, pincode, true) || [];
      const { lowerLimit, upperLimit } = findLowerAndUpperLimit(
        items.map(({ eddUpper, eddLower }) => ({ eddUpper, eddLower }))
      );
      const edd_min = setGADateFormat(lowerLimit);
      const edd_max = setGADateFormat(upperLimit);
      const date1 = new Date();
      const date2 = new Date(upperLimit);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if ((luxe && totalNSItem) || (newDesignLuxe && totalNSItem)) {
        gtmEventPush({
          event: 'cta_disabled',
          event_category: 'errors interactions',
          event_action: 'cta disabled',
          store_type: 'luxe',
          event_label:
            totalNSItem > 0 ? 'Item is out of stock' : totalOOSItem > 0 ? 'Servicibility' : false,
          error_status_code: '',
          network_type: ''
        });
      }
      if (totalNSItem > 0) {
        gtmEventPush({
          event: 'errors_interactions',
          event_category: 'errors interactions',
          event_action: 'business error',
          store_type: name || 'ajio',
          event_label: `${errorType} - ${errorMsg}`
        });
      }
      if (totalOOSItem > 0) {
        gtmEventPush({
          event: 'errors_interactions',
          event_category: 'errors interactions',
          event_action: 'business error',
          store_type: name || 'ajio',
          event_label: `${oosError} - ${oosErrorMsg}`
        });
      }
      gtmPagePush(pageName, pageType, window.__ENV__, {
        store: name,
        number_of_oos: totalOOSItem,
        out_of_stock_list: totalOOSItemList,
        edd_type: lowerLimit && upperLimit ? 'range' : 'date',
        default_address_pincode,
        default_address,
        estimate_delivery_date: diffDays,
        edd_max: edd_max || edd_min || '',
        edd_min: edd_min || edd_max || '',
        cta_disabled:
          totalNSItem > 0 ? 'Item is out of stock' : totalOOSItem > 0 ? 'Servicibility' : false
      });

      // gtmPagePush(pageName, pageType, window.__ENV__ || '', { cta_disabled:'', default_address_pincode, default_address});
    }
    if (value && shippingAssuredGifts === 'ON' && this?.props?.assuredDataFlag) {
      console.log('TRACK GAME NOT FOUND EXCEPTION - edd/index.js componentDidMount');
      this.props.fetchAssuredGift({ isRequestOrginIsBrowser: true }, null, null, value);
    }
  }

  render() {
    const {
      items,
      header,
      isDeliverableItems = true,
      cartItem,
      moveAllNonDeliverableItemToCloset,
      setMoveToClosetModal,
      showHeader = true,
      getTitle,
      pincode,
      isShowingInModal,
      listOfNonDeliverableItems = [],
      device = '',
      luxe,
      newDesignLuxe,
      assuredData,
      isAssured,
      assuredConstants,
      assuredDataFlag,
      cart = {},
      enableGiftWithProduct = false,
      enablePriorityDelivery=false,
      priorityDeliveryConfig={},
      enablePDPhase2 = false,
      enableRushDelivery=false,
      priorityDeliverySLPTagsConfig = {},
      enableSubscription = false,
      ajioMembershipConfig = {},
      memberShipStaticValues = {},
      returnCodCommunication = {},
      enableNonReturnableProductRevamp = false,
      isGSTSelected = false,
      revampConfig = {},
      b2cSellerEnabled = false
    } = this.props;
    const { PD_ICON = '', RUSH_ICON='', RD_ICON='' } = priorityDeliveryConfig;
    const rushPDPBadging = replaceWithJioCDN(RD_ICON) || `${properties.getProperty('imageBaseUrl')}/static/img/rushDeliveryTagIcon.svg`;
    const { PLP_BUCKET = {} } = priorityDeliverySLPTagsConfig;
    const { orderSummary: { orderTotal: { value = 0 } = {} } = {} } = cart;
    const { shippingAssuredGifts = 'OFF' } = isAssured;
    const showAssuredGiftsData = shippingAssuredGifts === 'ON';
    const { hasGift } = assuredData;
    let itemsGroupEstimDateWise = {};

    const { SPC_DISCLAIMER_TEXT } = SubscriptionStaticKeys; 

    const priorityDeliveryProductCount = items.reduce((accumulator, currentValue) => {
      const { isApplied } = readAppliedDeliveryOption(
        currentValue?.servicabilityInfo,
        SHIPPING_ACTION.PRIORITY
      );
      if (isApplied) {
        accumulator += 1;
      }
      return accumulator;
    }, 0);
    
    items.forEach(item => {
      const { eddLower, eddUpper } = item;
      const range = getDateRange({ eddLower, eddUpper });
      //check for single date
      if (!isDeliverableItems) {
        if (itemsGroupEstimDateWise['nonDelivarableItems']) {
          itemsGroupEstimDateWise['nonDelivarableItems'].push(item);
        } else {
          itemsGroupEstimDateWise['nonDelivarableItems'] = [item];
        }
      } else {
        if (itemsGroupEstimDateWise[range]) {
          itemsGroupEstimDateWise[range].push(item);
        } else {
          itemsGroupEstimDateWise[range] = [item];
        }
      }
    });

    if (itemsGroupEstimDateWise && Object.keys(itemsGroupEstimDateWise).length === 0) {
      return null;
    } else {
      itemsGroupEstimDateWise = Object.keys(itemsGroupEstimDateWise)
        .sort()
        .map(key => itemsGroupEstimDateWise[key]);
    }

    let isMembershipProduct = false;

    return (
      <div className={!isDeliverableItems && isShowingInModal ? 'not-deliverable-item' : ''}>
        {((isDeliverableItems && listOfNonDeliverableItems.length == 0) || !isDeliverableItems) && (
          <div className="subHeader">
            {device !== 'mobile' && (
              <span className={newDesignLuxe ? 'ic-address' : 'ic-Box'}></span>
            )}
            <div
              className={luxe ? 'luxe-content-header' : 'content-header'}>
              <strong aria-label="Expected Delivery"
             role='heading' aria-level={2}>Expected Delivery</strong>
              {(enablePriorityDelivery || enablePDPhase2) && !enableRushDelivery &&          //when rush is available dont show product count
              priorityDeliveryProductCount > 0 &&
              device === 'mobile' ? (
                <div className="pd-est-div">
                  <img src={PD_ICON} alt="PD icon" />
                  Delivery selected on {priorityDeliveryProductCount}{' '}
                  {priorityDeliveryProductCount === 1 ? 'Product' : 'Products'}
                </div>
              ) : (
                <div aria-label="Estimated delivery dates for your order" role='text'>
                  Estimated delivery dates for your order
                </div>
              )}
            </div>
          </div>
        )}
        {typeof getTitle === 'function' && (
          <div className="edd-items-list__header">
            {getTitle({
              noOfItems: items.length,
              totalItems: cartItem.length,
              className: 'edd-items-list__header__text',
              pincode: pincode
            })}
          </div>
        )}
        {items && items.length && (
          <div className="edd-items-list" role='list'>
            {items.map((item, index) => {
              const { eddLower, eddUpper, reasonForNotServiceability = 'NS' } = item;
              const range = getDateRange({ eddLower, eddUpper });
              const {
                images = [],
                code,
                exclusiveTill = '',
                productTag = '',
                isGiftProduct = false
              } = item;
              // Reads the nested (legacy) and flat (multiseller, keyed by
              // shippingAction) servicabilityInfo shapes alike.
              const { isApplied, deliverySLA } = readAppliedDeliveryOption(
                item?.servicabilityInfo,
                SHIPPING_ACTION.PRIORITY
              );
              const {
                isApplied: isRushApplied,
                deliverySLA: rushDeliverySLA
              } = readAppliedDeliveryOption(item?.servicabilityInfo, SHIPPING_ACTION.RUSH);
              const productTagValue = exclusiveTill ? 'EXCLUSIVE' : productTag;
              const { valueWithUnit: sizeOrNot, hideSizes } = beautyCheck(
                item.variantOptionQualifiers
              );
              if (item?.isMembershipArticle) {
                isMembershipProduct = true;
              }
              const msiteReturnPolicy =
                device === 'mobile' &&
                enableNonReturnableProductRevamp &&
                returnCodCommunication?.isCartEnabled
                  ? getReturnPolicySection(item, revampConfig, isGSTSelected, true)
                  : null;
              const ariaLabelForItem =
                device === 'mobile'
                  ? [
                      // Visual badges on image
                      enableGiftWithProduct && isGiftProduct ? 'Gift product.' : '',
                      productTagValue ? `${productTagValue}.` : '',

                      // Delivery section (shown first in UI)
                      isDeliverableItems
                        ? `Delivery ${
                            enableRushDelivery && isRushApplied && rushDeliverySLA
                              ? PLP_BUCKET[rushDeliverySLA]
                              : enablePDPhase2 &&
                                deliverySLA &&
                                isApplied
                              ? PLP_BUCKET[deliverySLA]
                              : range
                          }.`
                        : reasonForNotServiceability === 'OOS'
                        ? 'Out of stock.'
                        : 'Not deliverable to your location.',

                      // Delivery badge
                      enableRushDelivery && isRushApplied
                        ? 'Rush delivery.'
                        : (enablePriorityDelivery || enablePDPhase2) &&
                          isApplied
                        ? 'Priority delivery.'
                        : '',

                      // Product details
                      item.brandName,
                      item.name,

                      // Size
                      !isMembershipProduct &&
                      !(sizeOrNot || hideSizes) &&
                      item.size
                        ? `Size ${
                            manageSizeName(item.size)
                              ? manageSizeName(item.size)
                              : extractRange(item.size)
                              ? extractRange(item.size)
                              : item.size
                          }.`
                        : '',

                      // Seller
                      b2cSellerEnabled && item?.sellerName ? `Seller ${item.sellerName}.` : '',

                      // Return policy
                      enableNonReturnableProductRevamp &&
                      returnCodCommunication?.isCartEnabled &&
                      item?.returnPolicyLabel
                        ? item.returnPolicyLabel
                        : ''
                    ]
                      .filter(Boolean)
                      .join(' ')
                  : '';
              const eachItemContent = (
                <div key={index} className="edd-items-list__each-item" role='listitem' aria-label={ariaLabelForItem}>
                  <div
                    className={`edd-items-list__images-container ${
                      luxe && isShowingInModal ? 'showing-in-modal' : ''
                    }`}
                    aria-hidden={device === 'mobile'}
                  >
                    <img
                      className={
                        luxe && device === 'mobile'
                          ? 'edd-items-list__images-container__luxe_image'
                          : 'edd-items-list__images-container__image'
                      }
                      src={getImageUrlFromProductImages(images)}
                      // alt={getImageAltTextFromProductImages(images) || "product image"}
                      alt=""
                      onError={this.handleError}
                    />
                    {enableGiftWithProduct && isGiftProduct && (
                      <img
                        style={{
                          position: 'absolute',
                          bottom: '12px'
                        }}
                        src={`${imageBaseRef}${luxe ? 'FreeTagLuxe.svg' : 'FreeTag.svg'}`}
                        aria-hidden="true"
                        alt="Free Tag"
                      />
                    )}
                    {device === 'mobile' && productTagValue ? (
                      <div
                        className={
                          luxe ? 'edd-items-list__luxe_exclusive' : 'edd-items-list__exclusive'
                        }
                        aria-label={productTagValue}
                      >
                        <Text variant="T7" weight="bold" color="White">
                          {productTagValue}
                        </Text>
                      </div>
                    ) : null}
                    {device !== 'mobile' && productTagValue ? (
                      <div className="edd-items-list-desk__exclusive" aria-label={productTagValue}>
                        <Text>{productTagValue}</Text>
                      </div>
                    ) : null}
                  </div>
                  {isDeliverableItems && showHeader && (
                    <div className="edd-items-list__header" aria-hidden={device === 'mobile'}>
                      <div
                        className={
                          luxe && device === 'mobile'
                            ? 'edd-items-list__header__text__luxe_date'
                            : 'edd-items-list__header__text__date'
                        }
                        // aria-label={range}
                        role="text"
                        aria-label={`Priority delivery ${enablePDPhase2 && deliverySLA && isApplied ? PLP_BUCKET[deliverySLA] : range}`}
                      >
                      <strong>
                        {enableRushDelivery && isRushApplied && rushDeliverySLA ? PLP_BUCKET[`${rushDeliverySLA}`] :
                        (enablePDPhase2 && deliverySLA && isApplied ? PLP_BUCKET[`${deliverySLA}`] : range)}{' '}
                      </strong>

                      {                                                 //shipping page rush badging changes
                        enableRushDelivery && isRushApplied &&
                        device === 'mobile' && (
                          <img
                            src={rushPDPBadging}
                            alt="RUSH icon"
                            style={{ maxWidth: '70px', maxHeight: '20px', paddingLeft: '5px' }}
                          />
                        )
                      }
                      {(enablePriorityDelivery || enablePDPhase2) && !(enableRushDelivery && isRushApplied) &&
                        isApplied &&
                        device === 'mobile' && (
                          <img
                            src={isRushApplied ? replaceWithJioCDN(RD_ICON) : replaceWithJioCDN(PD_ICON)}
                            alt={isRushApplied ? "Rush Icon" : "PD icon"}
                            style={{ maxWidth: '70px', maxHeight: '20px', paddingLeft: '10px' }}
                            aria-hidden="true"
                          />
                        )}
                      </div>
                      {device === 'mobile' && (
                        <ProductLabel
                          title={item.brandName}
                          description={item.name}
                          isGift={!!(enableGiftWithProduct && isGiftProduct )}
                          volume={sizeOrNot}
                          luxe={luxe}
                          pageType="shipping"
                        />
                      )}
                      {device !== 'mobile' && (
                        <span
                          className="edd-items-list__header__brand marginAdd"
                          aria-label={item.brandName ? item.brandName.toString().toLowerCase() : ''}
                        >
                          {item.brandName ? item.brandName.toString().toLowerCase() : ''}
                        </span>
                      )}
                      {device !== 'mobile' && (
                        <span
                          className="edd-items-list__header__text marginAdd"
                          aria-label={`${item.name} ${!!sizeOrNot ? ` | ${sizeOrNot}` : ''}`}
                        >
                          {item.name} {!!sizeOrNot ? ` | ${sizeOrNot}` : ''}
                        </span>
                      )}
                      {/* Desktop keeps the seller under the product name, above
                          the return policy — the same line the cart tile carries.
                          Msite puts it below the size instead (see below). */}
                      {device !== 'mobile' && b2cSellerEnabled && item.sellerName && (
                        <span className="edd-items-list__header__seller">
                          {`Seller: ${item.sellerName}`}
                        </span>
                      )}
                      {device !== 'mobile' &&
                        enableNonReturnableProductRevamp &&
                        returnCodCommunication?.isCartEnabled &&
                        getReturnPolicySection(item, revampConfig, isGSTSelected)}
                      {device === 'mobile' && !isMembershipProduct && !(sizeOrNot || hideSizes) && (
                        <span
                          aria-label={`Size ${manageSizeName(item.size) ? manageSizeName(item.size) : (extractRange(item.size) ? extractRange(item.size) : item.size)}`}
                        >
                          <span aria-hidden="true" className={
                            luxe
                              ? 'edd-items-list__header__text__luxe_Size'
                              : 'edd-items-list__header__text__Size'
                          }>
                            Size {item.size}
                          </span>
                        </span>
                      )}
                      {/* Msite: seller sits under the size line, per the B2C
                          shipping design. Read from the entry rather than the
                          scopedView card — by this point the line is committed
                          to a seller, so the bag is the source of truth.
                          aria-hidden: the row's own aria-label already says it. */}
                      {device === 'mobile' && b2cSellerEnabled && item.sellerName && (
                        <span className="edd-items-list__header__seller" aria-hidden="true">
                          {`Seller: ${item.sellerName}`}
                        </span>
                      )}
                    </div>
                  )}
                  {!isDeliverableItems && showHeader && (
                    <div
                      className={`edd-items-list__header ${
                        device === 'mobile' ? 'errorMesgMobile' : ''
                      }`}
                    >
                      {reasonForNotServiceability === 'NS' && (
                        <span
                          className={
                            luxe && device === 'mobile'
                              ? 'edd-items-list__header__text__luxe_notDeliver'
                              : 'edd-items-list__header__text__notDeliver'
                          }
                        >
                          <strong>{item?.stockInfo?.stockErrorDescription?.length > 0 && item?.isMembershipArticle ? `${item?.stockInfo?.stockErrorDescription}` : 'Not deliverable to your location'}</strong>
                        </span>
                      )}
                      {reasonForNotServiceability === 'OOS' && (
                        <span
                          className={
                            luxe && device === 'mobile'
                              ? 'edd-items-list__header__text__luxe_notDeliver'
                              : 'edd-items-list__header__text__notDeliver'
                          }
                        >
                          <strong>{item?.stockInfo?.stockErrorDescription?.length > 0 && item?.isMembershipArticle ? `${item?.stockInfo?.stockErrorDescription}` : 'Out of Stock'}</strong>
                        </span>
                      )}
                      {!isShowingInModal && (
                        <span
                          className={
                            luxe && device === 'mobile'
                              ? 'edd-items-list__header__luxe_move-to-cloest'
                              : 'edd-items-list__header__move-to-cloest'
                          }
                          onClick={this.setMoveToClosetModal}
                          tabIndex={0}
                          role='button'
                        >
                          <strong>Remove {newDesignLuxe ? 'from bag' : ''}</strong>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              );
              return enableNonReturnableProductRevamp && device === 'mobile' ? (
                <div key={index} className="edd-items-list__item-row-wrapper">
                  {eachItemContent}
                  {msiteReturnPolicy}
                </div>
              ) : eachItemContent;
            })}
            {!isDeliverableItems &&
              itemsGroupEstimDateWise &&
              Object.keys(itemsGroupEstimDateWise) > 0 &&
              itemsGroupEstimDateWise['nonDelivarableItems'].length === items.length && (
                <span className="edd-items-list__divider" />
              )}
          </div>
        )}
        {enableSubscription && ajioMembershipConfig?.isEnableForSPC && isMembershipProduct && device === 'mobile' && (
          <div
            className={`subscriptionTextSPC ${newDesignLuxe ? 'luxeSubscriptionTextSPC' : ''}`}
          >
            {memberShipStaticValues?.[SPC_DISCLAIMER_TEXT]}
          </div>
        )}
        <Feature featureName="assured-gifts">
          <Variant id="0">{null}</Variant>
          <Variant id="1">
            {!newDesignLuxe &&
              assuredDataFlag &&
              showAssuredGiftsData &&
              device === 'mobile' &&
              hasGift && <AssuredGiftsWidget assuredConstants={assuredConstants} value={value} />}
          </Variant>
        </Feature>
      </div>
    );
  }
}

class DeliverableItems extends PureComponent {
  render() {
    const {
      cartItem,
      eddDetails,
      activePincode,
      device = '',
      gtmObj,
      luxeFlags,
      name,
      newDesignLuxe,
      cart,
      fetchAssuredGift,
      assuredData,
      isAssured,
      assuredConstants,
      assuredDataFlag,
      enableGiftWithProduct,
      enablePriorityDelivery=false,
      priorityDeliveryConfig={},
      enableSubscription,
      ajioMembershipConfig,
      memberShipStaticValues,
      priorityDeliverySLPTagsConfig={},
      enablePDPhase2 = false,
      enableRushDelivery=false,
      returnCodCommunication = {},
      enableNonReturnableProductRevamp = false,
      isGSTSelected = false,
      revampConfig = {},
      b2cSellerEnabled = false
    } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    let items = getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, true);
    let listOfNonDeliverableItems = getServiceOrNonServicabilityItems(
      cartItem,
      eddDetails,
      activePincode,
      false
    );
    const availableItems = items.filter(
      item => !(item?.stockInfo?.stockErrorDescription?.length > 0 && item?.isMembershipArticle)
    );
    console.log("🚀 ~ DeliverableItems ~ render ~ availableItems:", availableItems)
    return (
      <CartItemsWithEDD
        items={availableItems}
        header={'Deliverable Items'}
        isDeliverableItems={true}
        cartItem={cartItem}
        listOfNonDeliverableItems={listOfNonDeliverableItems}
        device={device}
        gtmObj={gtmObj}
        eddDetails={eddDetails}
        activePincode={activePincode}
        luxe={luxe}
        newDesignLuxe={newDesignLuxe}
        name={name}
        cart={cart}
        fetchAssuredGift={fetchAssuredGift}
        assuredData={assuredData}
        isAssured={isAssured}
        assuredConstants={assuredConstants}
        assuredDataFlag={assuredDataFlag}
        enableGiftWithProduct={enableGiftWithProduct}
        enablePriorityDelivery={enablePriorityDelivery}
        priorityDeliveryConfig={priorityDeliveryConfig}
        enableSubscription={enableSubscription}
        ajioMembershipConfig={ajioMembershipConfig}
        memberShipStaticValues={memberShipStaticValues}
        priorityDeliverySLPTagsConfig={priorityDeliverySLPTagsConfig}
        enablePDPhase2={enablePDPhase2}
        enableRushDelivery={enableRushDelivery}
        returnCodCommunication={returnCodCommunication}
        enableNonReturnableProductRevamp={enableNonReturnableProductRevamp}
        isGSTSelected={isGSTSelected}
        revampConfig={revampConfig}
        b2cSellerEnabled={b2cSellerEnabled}
      />
    );
  }
}

class EDDItemDetailsComp extends PureComponent {
  constructor() {
    super();
    this.state = {
      itemNotDeliverable: false
    };
  }

  componentDidMount() {
    const {
      addProductToWishlist,
      oosItemReviewPopup,
      showModal,
      cart: { oosItemListPayment = [] } = {},
      device = ''
    } = this.props;
    if (oosItemReviewPopup) {
      var oosItemList = oosItemListPayment;
      if (oosItemList && oosItemList.length > 0) {
        device !== 'mobile' && showModal(ModalTypes.EDD_MOVE_TO_CLOEST, {});
        device === 'mobile' &&
          this.setState({
            itemNotDeliverable: true
          });
        oosItemList.map(itemCode => {
          addProductToWishlist(itemCode);
        });
      }
    }
  }
  getAddToWishListTitleForCart = () => {
    let {
      cart: { oosItemListPayment = [] } = {},
      cartItem,
      device = '',
      luxeFlags,
      name
    } = this.props;
    let totalItems = cartItem.length;
    var oosItemList = oosItemListPayment;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    return (
      // <p className="edd-items-list__header__text" style={{ padding: "5px" }}>
      //   <b>{oosItemList.length}/{totalItems + oosItemList.length} product{oosItemList.length === 1 ? "" : "s"}</b>
      //   in your bag are out of stock. The products will be <strong>moved to your closet.</strong> Please review bag to place order.
      // </p>
      // <p className="edd-items-list__header__text" >
      //   Some products in your bag are out of stock. They will be <b>moved to your closet.</b> Please review bag to place order.
      // </p>
      <div className={luxe && device === 'mobile' ? 'cart-des-content' : 'cart-des-content'}>
        We couldn’t process your payment as one or more products in your bag have gone out of stock.
        This might happen due to heavy demand.
      </div>
    );
  };

  getAddToWishListTitle = ({ noOfItems, totalItems, className, pincode }) => {
    const { device = '', luxeFlags, name } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    return (
      // <p className={className} style={{ padding: '5px' }}>
      //   <b>
      //     {noOfItems}/{totalItems} item{noOfItems === 1 ? '' : 's'}
      //   </b>{' '}
      //   in your bag are not deliverable. The products will be <strong>moved to your closet</strong>.
      // </p>
      <p className={luxe && device === 'mobile' ? 'edd-items-list__header__luxe_text' : className}>
        {luxe && device === 'mobile' ? (
          <>
            The following products are not deliverable to your location. They will be{' '}
            <b>moved to your wishlist</b>.
          </>
        ) : (
          <>
            The following products are not deliverable to your location. They will be{' '}
            <b>moved to your closet</b>.
          </>
        )}
      </p>
    );
  };
  handleClose = () => {
    this.props.setMoveToClosetModal(false);
  };
  moveAllOOSItemToCloset = () => {
    const { hideModal, setCartPaymentOOSError, device } = this.props;
    setCartPaymentOOSError();
    device !== 'mobile' && hideModal(ModalTypes.EDD_MOVE_TO_CLOEST, {});
    device === 'mobile' &&
      this.setState({
        itemNotDeliverable: false
      });
  };

  showItemDeliverable = () => {
    this.setState({
      itemNotDeliverable: true
    });
  };
  hideProductUnavailableModal = () => {
    this.setState({
      itemNotDeliverable: false
    });
  };

  render() {
    const {
      activePincode,
      showMoveToClosetModal,
      moveAllNonDeliverableItemToCloset,
      movingAllNonDeliverableItemsToCloset,
      isCartItemsEDDFetching = false,
      classes = '',
      oosItemReviewPopup = false,
      pickFromStoreFlag = true,
      cart: { oosItemListPayment = [] } = {},
      device = '',
      luxeFlags,
      name,
      newDesignLuxe,
      enableGiftWithProduct,
      enablePriorityDelivery=false,
      priorityDeliveryConfig={},
      enableSubscription,
      ajioMembershipConfig,
      memberShipStaticValues,
      priorityDeliverySLPTagsConfig={},
      enablePDPhase2 = false
    } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    if (!activePincode && !oosItemReviewPopup) {
      return null;
    }
    if (isCartItemsEDDFetching && !oosItemReviewPopup) {
      return <div id="edd-items" className="edd-loader shipping-page"></div>;
    }
    return (
      <div className="edd-container">
        <div className="edd-container-divider"></div>
        {oosItemReviewPopup && device !== 'mobile' ? (
          <hr className={!pickFromStoreFlag ? 'pick-rollback' : ''} aria-hidden="true"/>
        ) : (
          ''
        )}
        <div id="edd-items" className={classes}>
          {!oosItemReviewPopup && (
            <React.Fragment>
              <NotDeliverableItems {...this.props} showItemDeliverable={this.showItemDeliverable} />
              <DeliverableItems {...this.props} showItemDeliverable={this.showItemDeliverable} />
            </React.Fragment>
          )}
          {(showMoveToClosetModal || oosItemReviewPopup) && device === 'mobile' && (
            <Dialog
              showDialog={this.state.itemNotDeliverable}
              type="drawer"
              onCancel={this.hideProductUnavailableModal}
              customClass={luxe ? 'order-remove-dialog' : undefined}
            >
              {/* mtc=move-to-closet */}
              <div className="mtc-modal">
                {/* <h2 className="mtc-modal__header">{oosItemReviewPopup ? 'Order Cannot Be Processed' : 'Review Bag'}</h2> */}
                <h2 className={luxe ? 'mtc-modal__luxe_header' : 'mtc-modal__header'}>
                  {luxe
                    ? oosItemReviewPopup
                      ? 'Payment failed. Remove Products From Bag'
                      : 'Remove Products From Bag'
                    : oosItemReviewPopup
                    ? 'Products out of Stock'
                    : 'Products out of Stock'}
                </h2>
                {!oosItemReviewPopup && (
                  <NotDeliverableItems
                    {...this.props}
                    showHeader={true}
                    getTitle={this.getAddToWishListTitle}
                    isShowingInModal={true}
                  />
                )}
                {oosItemReviewPopup && this.getAddToWishListTitleForCart()}
                <p
                  className={`mtc-modal__description ${
                    device === 'mobile' ? (luxe ? 'luxe-mobileDesc' : 'mobileDesc') : ''
                  }`}
                >
                  Please remove that product from your bag and try making the payment again.
                </p>
                <div className={luxe ? 'mtc-modal__luxe_footer' : 'mtc-modal__footer'}>
                  <button
                    className={luxe ? 'mtc-modal__luxe_footer__mtc' : 'mtc-modal__footer__mtc'}
                    onClick={
                      oosItemReviewPopup
                        ? this.moveAllOOSItemToCloset
                        : moveAllNonDeliverableItemToCloset
                    }
                  >
                    <strong>Go To Bag</strong>
                    {movingAllNonDeliverableItemsToCloset && '...'}
                  </button>
                </div>
              </div>
            </Dialog>
          )}
          <Modal
            name={ModalTypes.EDD_MOVE_TO_CLOEST}
            className={`${ModalTypes.EDD_MOVE_TO_CLOEST} oosDialog`}
            id={ModalTypes.EDD_MOVE_TO_CLOEST}
            disableOutsideClick={oosItemReviewPopup ? true : false}
            closeButton={oosItemReviewPopup ? false : true}
          >
            {/* mtc=move-to-closet */}
            <div className="mtc-modal">
              {/* <h2 className="mtc-modal__header">{oosItemReviewPopup ? 'Order Cannot Be Processed' : 'Review Bag'}</h2> */}
              <h2 className={'mtc-modal__header'}>
                {newDesignLuxe ? 'Review Bag' : 'Products Unavailable'}{' '}
              </h2>
              {!oosItemReviewPopup && (
                <NotDeliverableItems
                  {...this.props}
                  showHeader={true}
                  getTitle={this.getAddToWishListTitle}
                  isShowingInModal={true}
                />
              )}
              {oosItemReviewPopup && this.getAddToWishListTitleForCart()}
              <p
                className={`mtc-modal__description ${
                  device === 'mobile' ? (luxe ? 'luxe-mobileDesc' : 'mobileDesc') : ''
                }`}
              >
                Bag total will be updated and discounts will be re-calculated.
              </p>
              <div className={'mtc-modal__footer'}>
                <button
                  className={'mtc-modal__footer__mtc footerOld'}
                  onClick={
                    oosItemReviewPopup
                      ? this.moveAllOOSItemToCloset
                      : moveAllNonDeliverableItemToCloset
                  }
                >
                  Go To Bag
                  {movingAllNonDeliverableItemsToCloset && '...'}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToPropsITEMS = state => {
  const {
    cartItem,
    cart,
    addressBook = {},
    edd: {
      eddDetails = {},
      activePincode,
      showMoveToClosetModal,
      movingAllNonDeliverableItemsToCloset,
      isCartItemsEDDFetching
    },
    flags = {}
  } = state;
  const { addresses = [], postalCode = '' } = addressBook;
  const gtmObj = {};
  gtmObj['default_address'] = addresses.length ? addresses[0]?.defaultAddress : false;
  gtmObj['default_address_pincode'] = postalCode;
  const assuredData = getAssuredGiftData(state);
  const assuredDataFlag = getAssuredGifts(flags);
  const isAssured = getAssuredGiftsFlag(state);
  const assuredConstants = getAssuredFlags(state);

  return {
    cart,
    cartItem,
    eddDetails,
    activePincode,
    showMoveToClosetModal,
    movingAllNonDeliverableItemsToCloset,
    isCartItemsEDDFetching,
    gtmObj,
    luxeFlags: getLuxeFlags(flags),
    name: getCurrentStore(state),
    newDesignLuxe:
      getLuxeFlags(flags).isDesktopThemeEnable === 'ON' && getCurrentStore(state) === 'luxe',
    assuredData,
    isAssured,
    assuredConstants,
    assuredDataFlag,
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    enablePriorityDelivery: getPriorityDeliveryPreOrderFlag(flags),
    enableRushDelivery: getRushDeliveryFlag(state),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state),
    enableSubscription: getEnableAjioMemberShipProgram(flags, state),
    ajioMembershipConfig: getAjioMemberShipConfig(flags, state),
    memberShipStaticValues: state?.cacheData?.staticContent,
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
    enablePDPhase2: getPriorityDeliveryPhase2Flag(flags),
    returnCodCommunication: getReturnCodCommunication(state),
    enableNonReturnableProductRevamp: getEnableNonReturnableProductRevamp(state),
    revampConfig: getEnableNonReturnableProductRevampConfig(state),
    b2cSellerEnabled: getB2cSellerFlag(state),
    isGSTSelected: (() => {
      const gstDetails = state?.cart?.gstDetails || {};
      return gstDetails?.constructor === Object && Object.keys(gstDetails).length > 0;
    })(),
  };
};

const mapDispatchToPropsITEMS = dispatch => {
  return {
    moveAllNonDeliverableItemToCloset: () => dispatch(moveAllNonDeliverableItemToCloset()),
    setMoveToClosetModal: status => dispatch(setMoveToClosetModal(status)),
    showModal: (name, configs) => dispatch(showModal(name, configs)),
    hideModal: (name, configs) => dispatch(hideModal(name, configs)),
    addProductToWishlist: productId => dispatch(addProductToWishlist(productId, false)),
    setCartPaymentOOSError: () => dispatch(setCartPaymentOOSError([])),
    fetchAssuredGift: (reqObj, callback, isRecursivelyCalling, orderValue) =>
      dispatch(fetchAssuredGift(reqObj, callback, isRecursivelyCalling, orderValue))
  };
};

export const EDDItemDetails = connect(
  mapStateToPropsITEMS,
  mapDispatchToPropsITEMS
)(EDDItemDetailsComp);
